import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Stack, Text } from 'components'
import { IconInfoCircle } from '@tabler/icons-react'

export const EmptyState = memo(function EmptyState() {
  const { t } = useTranslation()
  
  return (
    <Alert 
      icon={<IconInfoCircle size='1.4rem' />} 
      color='yellow' 
      variant='light'
    >
      <Stack spacing={4}>
        <Text size='sm' weight={500}>
          {t('new_project_page.no_suggestions_found')}
        </Text>
        <Text size='xs' color='dimmed'>
          {t('new_project_page.no_suggestions_description')}
        </Text>
      </Stack>
    </Alert>
  )
})